import * as React from 'react';
import { DefaultLayout } from '../../../../components/DefaultLayout';
import { Seo } from "../../../../components/Seo";

import { YandexMetrika } from '../../../../components/YandexMetrika';
import { MailRu } from '../../../../components/MailRu';
import { TikTok } from '../../../../components/TikTok';
import { VKPixel } from '../../../../components/VKPixel';
import { AdvCake } from '../../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../../components/HeaderLogoAndTel";
import { FooterMedium } from "../../../../components/FooterMedium";
import { GetCourseWidget } from "../../../../components/GetCourseWidget";

import {
  Whom,
  Education,
  Offer,
  Reviews,
  Get,
  Attention,
  ChatVideo,
  Cost,
  main
} from "../../../../components/LandingTemplates/kuratorskoe_soprovozhdenie";

import * as screen1 from "./styles/screen1.module.scss";

const Screen1 = () => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel phoneHide={true}/>
        <div className={screen1.screen1__container}>
          <div className={screen1.screen1__wrapper}>
            <div className={screen1.screen1__titleWrapper}>
              <h1 className={screen1.screen1__title}>Кураторское сопровождение в&nbsp;мини-группах&nbsp;для учеников
                курса&nbsp;«Учись учиться 5-7&nbsp;класс»</h1>
              <h2 className={screen1.screen1__subtitle}>Поможет ребёнку за&nbsp;20&nbsp;недель освоить все навыки и&nbsp;основные материалы курса и&nbsp;перейти к&nbsp;самостоятельной&nbsp;работе</h2>
            </div>
            <div className={screen1.screen1__linkWrapper}>
              <a className={`${screen1.screen1__link} ${main.mainBtn}`} href="#cost" data-target="#course">
                Оставить заявку
              </a>
            </div>
          </div>
          <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_detey/kuratorskoe_soprovozhdenie-5_7/bg-kurator-uu-5-7-item.png" alt=""/>
        </div>
      </div>
    </header>
  );
};

const TITLE = 'Кураторское сопровождение в мини-группах для учеников курса «Учись учиться 5-7 класс»';
const DESCRIPTION = 'Поможет ребёнку за 20 недель освоить все навыки и основные материалы курса и перейти к самостоятельной работе';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1/>
      <Whom
        video={"https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_detey/kuratorskoe_soprovozhdenie-5_7/video/Screencast_chata_uu.mp4"}
        poster={"https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_detey/kuratorskoe_soprovozhdenie-5_7/phone-screencast-uu.png"}
      />
      <Education/>
      <Offer/>
      <Reviews/>
      <Get/>
      <Attention/>
      <ChatVideo
        name={"Михей:"}
        text={"«На протяжении курса я не столкнулся ни\u00A0с какими трудностями, потому что в\u00A0курсе всё очень доступно объясняется»"}
        video={"https://cdn.advance.ru/videos/65395_dX1YNiU4mweYfEpO"}
      />
      <Cost
        widgetFull={<GetCourseWidget hash={'81d7c40fc189627a8844d1f2d4ed32491f7a83d3'} id={'715594'}/>}
        fullText={""}
      />
    </main>

    <FooterMedium/>
  </DefaultLayout>
);

export default Page;
